import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  ScrollView,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  Dimensions,
  Alert,
  KeyboardAvoidingView,
} from "react-native";
import Text from "app/components/Text";
import Icon from "app/components/Icon";
import TouchableOpacity from "app/components/TouchableOpacity";
import TextInput from "app/components/TextInput";
import MomentList from "app/components/chapter/MomentList";
import chapterActions from "app/utils/chapterActions";
import valueActions from "app/utils/valueActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";
import timeHelpers from "app/utils/timeHelpers";
import valueHelpers from "app/utils/valueHelpers";
import ftueHelpers from "app/utils/ftueHelpers";
import filterHelpers from "app/utils/filterHelpers";
import {
  styleSheet,
  colors,
  sizes,
  screenRatio,
  WIDTH,
} from "app/utils/styleSheet";

import store from "app/redux/store";

import { StyleContext } from "app/contexts/Style";

export default class AdvancedSearch extends React.Component {
  static contextType = StyleContext;
  constructor(props) {
    super(props);
    let { navigation, route } = this.props;
    let query = route?.params?.query;
    this.state = {
      query,
      loading: !!query?.length,
      values: [],
    };
  }

  async componentDidMount() {
    let { query } = this.state;
    if (!!query?.length) {
      this.fetch();
    }
  }

  fetch = async () => {
    let { query } = this.state;
    let values = await valueActions.autocompleteValues(query, true);
    this.setState({ loading: false, values });
  };

  render() {
    let { loading, query, values } = this.state;

    return (
      <View style={this.styles().container}>
        <StatusBar style="auto" />
        <ScrollView nestedScrollEnabled keyboardShouldPersistTaps={"always"}>
          <View style={this.styles().content}>
            <TextInput
              keyboardAccType={"composer"}
              autoFocus={ENV.WEB}
              placeholderTextColor={this.context.colors.trim}
              value={query}
              inputRef={(r) => {
                // inputRef && inputRef(r);
                this.inputRef = r;
              }}
              // autoHeight={autoHeight}
              // onChangeHeight={onChangeHeight}
              // onFocus={() => {
              //   this.setState({ focused: true });
              //   this.props.onFocus && this.props.onFocus();
              // }}
              // onBlur={() => {
              //   this.setState({ focused: false });
              //   this.props.onBlur && this.props.onBlur();
              // }}
              // onKeyPress={(e) => {
              //   this.handleKeyPress(e);
              // }}
              onChangeText={(e) => {
                this.setState({ query: e });
              }}
              containerStyle={{ zIndex: 1 }}
              style={[
                styleSheet.input,
                { flex: 1, height: "auto", minHeight: undefined },
                { borderWidth: 0 },
                { minWidth: 80 },
              ]}
            />

            {loading ? (
              <ActivityIndicator />
            ) : (
              <View
                style={{
                  marginBottom: this.context.sizes.large,
                  padding: this.context.sizes.large,
                  borderWidth: 1,
                  borderRadius: this.context.sizes.borderRadius,
                  borderColor: this.context.colors.trim,
                }}
              >
                <MomentList
                  moments={values.map((value) => ({
                    value,
                    id: `value-${value.id}`,
                  }))}
                  ref={(ref) => (this.momentListRef = ref)}
                  hideBadgeRow
                  hideTags
                  parentIsValue
                  // valueBadges={badgeOption == "values"}
                  // horizontal={layoutOption == "horizontal"}
                  // valueBadges={badgeOption == "values"}
                />
                {values.map((value, i) => {
                  return (
                    <View key={i} style={{ flexDirection: "row" }}>
                      <Text
                        numberOfLines={1}
                        strike={!!value.completed_at}
                        style={[
                          {
                            flex: 1,
                            maxWidth: 400,
                            paddingHorizontal: this.context.sizes.base,
                            paddingVertical: ENV.WEB
                              ? this.context.sizes.tiny
                              : this.context.sizes.base,
                            backgroundColor: this.props.backgroundColor,
                            borderBottomWidth: 1,
                            borderColor: this.context.colors.trim,
                          },
                        ]}
                      >
                        <Icon
                          name={valueHelpers.getIcon(value)}
                          color={valueHelpers.colorAsHex(
                            value?.color || value.inherited_color,
                            this.context.colorScheme,
                          )}
                          size={this.context.sizes.default}
                        />{" "}
                        {valueHelpers.filterRichText(
                          value.title || value.text,
                          value,
                          undefined,
                          values,
                        )}
                      </Text>
                    </View>
                  );
                })}
              </View>
            )}
          </View>
        </ScrollView>
      </View>
    );
  }

  styles = () => ({
    container: {
      flex: 1,
      // justifyContent: "space-between",
      justifyContent: "stretch",
    },
    row: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      margin: this.context.sizes.large,
    },
    headerRow: {},
    chapCompWrapper: {
      marginTop: this.context.sizes.large,
      marginLeft: this.context.sizes.large,
    },
    content: {
      // alignSelf: "center",
      justifyContent: "stretch",
      // borderWidth: 1,
      minWidth: 500,
      minHeight: 400,
      padding: this.context.sizes.giant,
      // justify
    },
  });
}
